import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import accounts from "./modules/Accounts";
import permissions from "./modules/Permissions";
import auth from "./modules/Auth";
import roles from "./modules/Roles";
import fields from "./modules/Fields";
export default createStore({
  modules: {
    auth,
    accounts,
    permissions,
    roles,
    fields,
  },

  state: {
    hideConfigButton: false,
    sidebarCollapsed: false,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: "default",
  },

  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },

    toggleSidebarCollapse(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },

    sidebarType(state, payload) {
      state.sidebarType = payload;
    },

    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
  },

  actions: {},
  getters: {},

  plugins: [createPersistedState()],
});
